import { render } from "./AuditorioCard.vue?vue&type=template&id=fcfea994&scoped=true"
import script from "./AuditorioCard.vue?vue&type=script&lang=js"
export * from "./AuditorioCard.vue?vue&type=script&lang=js"

import "./AuditorioCard.vue?vue&type=style&index=0&id=fcfea994&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcfea994"]])

export default __exports__